import { isAxiosError } from 'axios';

interface NestProblemBody {
  message?: string | string[];
  code?: string;
}

export function apiErrorMessage(err: unknown): string {
  if (isAxiosError<NestProblemBody>(err)) {
    const raw = err.response?.data?.message;
    if (Array.isArray(raw)) {
      const joined = raw.filter(Boolean).join(' ');
      if (joined) return joined;
    }
    if (typeof raw === 'string' && raw.trim()) return raw;
    const code = err.response?.data?.code;
    if (code === 'ACCOUNT_LOCKED' || err.response?.status === 423) {
      return 'Trop de tentatives depuis ce réseau. Patientez quelques minutes ou changez de réseau.';
    }
  }
  if (err instanceof Error && err.message) return err.message;
  return 'Échec de la connexion';
}
